<template>
  <GeojsonLayer :sourceId="sourceId" :source="source" :layer="layerStyle" />
</template>

<script>
import GeojsonLayer from '@/components/map/mapbox-layers/GeojsonLayer.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LayerMeasureLineLines',
  components: {
    GeojsonLayer
  },
  props: {
    sourceId: {
      type: String,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    layerId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      isMeasurementActive: 'isMeasurementActive'
    }),
    ...mapState({
      currentTool: (state) => state.currentTool
    }),
    visibility() {
      return this.isMeasurementActive && this.currentTool === 'linemeasurement'
    },
    layerStyle() {
      return {
        id: this.layerId,
        source: this.sourceId,
        type: 'line',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
          visibility: this.visibility ? 'visible' : 'none'
        },
        paint: {
          'line-color': '#80b5b4',
          'line-width': 2.5
        },
        filter: ['in', '$type', 'LineString']
      }
    }
  }
}
</script>
